export default {
  LOAD_TASK_MONITOR (state, payload) {
    state.taskMonitorObject = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/taskMonitor/vuex/mutations.js